import { getAxiosClient } from "../../axios-client";
import { PostSubcontractorAddRequestBody, PostSubcontractorAddResponse } from "./types";

const axiosClient = getAxiosClient();
export const postSubcontractorAdd = async (body: PostSubcontractorAddRequestBody) => {
    return await axiosClient.ax.post<PostSubcontractorAddResponse>("/Subcontractor/SubcontractorAdd", body);
};